// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C-iW","name":"styles_name__3YnBY","phone":"styles_phone__3k4zs"};